import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App, { msalReady } from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from './app/store';
import './app/locales/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const store = configureStore();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

const renderApp = () =>
  createRoot(container).render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>,
  );

// A failed redirect is reported by <MsalProvider>, which receives the same result.
msalReady.then(renderApp, renderApp);

// Register service worker for notification handling
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://github.com/GoogleChrome/web-vitals
reportWebVitals();
